import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import React from "react"
import useChatClient from "../../hooks/useChatClient"

const StatusFilter = () => {
    const { status, setStatus } = useChatClient();    

    const handleChange = (event: SelectChangeEvent) => {
        setStatus(event.target.value as string);
    };

    return (
        <FormControl fullWidth>            
            <Select
                value={status}                
                onChange={handleChange}
                size="small"
            >
                <MenuItem value='All'>All</MenuItem>
                <MenuItem value='TicketOpen'>Open Tickets</MenuItem>
                <MenuItem value='MyOpenTickets'>My Open Tickets</MenuItem>
                <MenuItem value='TicketClosed'>Closed Tickets</MenuItem>
            </Select>
        </FormControl>
    )
}

export default StatusFilter;